import { render, staticRenderFns } from "./UserFormAPI.vue?vue&type=template&id=034a575e&scoped=true&"
import script from "./UserFormAPI.vue?vue&type=script&lang=js&"
export * from "./UserFormAPI.vue?vue&type=script&lang=js&"
import style0 from "./UserFormAPI.vue?vue&type=style&index=0&id=034a575e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034a575e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
